'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var input = require('./input-e08c130c.js');

var PasswordInfo = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  place-self: flex-start;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  place-self: flex-start;\n"])));
var InputContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  flex-grow: 1;\n  margin-right: 8px;\n"], ["\n  flex-grow: 1;\n  margin-right: 8px;\n"])));
var StyledPasswordInput = styled__default(input.Input)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  width: 368px;\n  margin-bottom: 20px;\n"], ["\n  width: 368px;\n  margin-bottom: 20px;\n"])));
var StyledLink = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: normal 14px/22px ", ";\n  color: ", ";\n  margin-bottom: 30px;\n  margin-left: 16px;\n  cursor: pointer;\n"], ["\n  font: normal 14px/22px ", ";\n  color: ", ";\n  margin-bottom: 30px;\n  margin-left: 16px;\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$primary;
});
var Label = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: normal 14px/24px ", ";\n  color: ", ";\n"], ["\n  font: normal 14px/24px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$greyDark;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.InputContainer = InputContainer;
exports.Label = Label;
exports.PasswordInfo = PasswordInfo;
exports.StyledLink = StyledLink;
exports.StyledPasswordInput = StyledPasswordInput;
